import React from 'react'

import moment from 'moment'

import { Grid } from '@material-ui/core'

import InputGroup from '../../../../../UI/Forms/InputGroup/InputGroup'

const AssignPeriod = ({ structure, inputChanged, translate }) => {
  const startDate = moment(structure?.assigned_date, 'YYYY-MM-DD')
  const endDate = moment(structure?.end_date, 'YYYY-MM-DD')

  return (
    <Grid container spacing={2} alignItems={'flex-end'} justify={'flex-end'}>
      <Grid item>
        <InputGroup
          variant={'outlined'}
          inputType={'datePicker'}
          label={translate('assignmentDate')}
          inputValue={startDate}
          noMargin
          changed={e =>
            inputChanged({ ...structure, assigned_date: e?.format('YYYY-MM-DD') || null })
          }
          touched={true}
          validations={{ required: true }}
        />
      </Grid>
      <Grid item>
        <InputGroup
          variant={'outlined'}
          inputType={'datePicker'}
          label={translate('assignmentEndDate')}
          inputValue={endDate}
          noMargin
          changed={e => inputChanged({ ...structure, end_date: e?.format('YYYY-MM-DD') || null })}
          invalid={!endDate.isValid() || endDate.diff(startDate) < 0}
          touched={true}
          validations={{ required: true }}
          validationError={translate('assignmentEndDateValidation')}
        />
      </Grid>
    </Grid>
  )
}

export default AssignPeriod
